import React from 'react';
import PropTypes from 'prop-types';
import {
  Container,
  Left,
  Right,
  StyledSvg,
  Description,
} from './journal-logo.css';

import journalHeader1 from 'images/journal/journal-1.png';

const JournalLogo = ({ description }) => (
  <Container>
    <Left>
      <StyledSvg viewBox="0 0 1315.91 453.02">
        <defs>
          <pattern
            id="journal-header-1"
            patternUnits="objectBoundingBox"
            width="1"
            height="1"
            viewBox="0 0 1307 363"
          >
            <image
              preserveAspectRatio="none"
              xlinkHref={journalHeader1}
              width="1307"
              height="363"
            />
          </pattern>
        </defs>
        <title>NDC Journal</title>
        <rect
          fill="url(#journal-header-1)"
          width="1307.75"
          height="389.25"
          x="7.66"
          y="0.5"
        />
        <rect
          fill="none"
          className="bg-brand-blue"
          width="1307.75"
          height="389.25"
          x="7.66"
          y="0.5"
        />
        <path d="M125.4,224.94H135V384.11H123.16L44.92,270.32c-7.61-11.4-16.1-24.36-21.69-33.75.22,15.42.22,30.18.22,41.58v106H14.06V224.94H25.91l78.25,113.79c7.6,11.4,16.09,24.37,21.68,33.54-.44-15.43-.44-30-.44-41.36Zm86.73,0H164.06V384.11h46.28c52.31,0,79.59-30.85,79.59-79.58S262.65,224.94,212.13,224.94ZM210.34,375.4H173.68V233.66H211.9c46.06,0,68,27.72,68,70.87C279.87,347.23,257.73,375.4,210.34,375.4Zm224.44-49.63h9.61c-4.24,38.45-31.07,61.92-66.61,61.92-43.6,0-70.87-33.53-70.87-83.16s27.27-83.17,70.87-83.17c34.2,0,59.46,21.24,65.72,57.24h-9.61c-6-31.3-27.5-48.52-56.11-48.52-38,0-61,30.18-61,74.45s23,74.44,61,74.44C407.73,379,430.53,359.3,434.78,325.77ZM598.19,224.94h9.62V338.73c0,29.06-18.11,49-48.07,49-29.73,0-47.84-19.9-47.84-49v-9.39h9.39v9.39c0,24.59,15,40.24,38.45,40.24,23.7,0,38.45-15.65,38.45-40.24Zm82.71,41.14c-31.52,0-52.31,24.59-52.31,60.36s20.79,60.36,52.31,60.36,52.54-24.59,52.54-60.36S712.42,266.08,680.9,266.08Zm0,112.44c-26.15,0-42.7-21-42.7-52.08s16.55-52.09,42.7-52.09c26.38,0,42.93,21,42.93,52.09S707.28,378.52,680.9,378.52ZM833.37,268.76h9.16V384.11h-8.94V359.75c-6.71,16.54-21,27.05-39.79,27.05-25.94,0-41.14-15.21-41.14-43.15V268.76h9.17v74c0,23.92,12.29,35.76,33.53,35.76,19,0,37.56-13.18,38-45.6Zm86.28-1.34c2.24,0,4.25,0,6.93.22v8.72c-2.23-.22-4.47-.22-6.26-.22-27.5,0-41.8,18.33-41.8,44v63.93h-9.17V268.76h8.72v27.05C883.44,281.28,896.4,267.42,919.65,267.42Zm113.79,41.8v74.89h-9.17v-74c0-23.92-12.29-35.77-33.53-35.77-19,0-37.56,13.19-38,45.6v64.16h-9.17V268.76h8.72v25c6.48-17,20.79-27.72,40-27.72C1018.24,266.08,1033.44,281.28,1033.44,309.22Zm111.32,57.23v-69.3c0-18.11-12.07-31.07-41.13-31.07-32,0-44.49,13.63-45.16,36.66h8.94c.9-20.12,11.18-28.62,36.22-28.62,23.25,0,32.19,9.17,32.19,23,0,12.07-4.47,18.11-23.47,20.57L1093.79,320c-28.84,3.58-40.24,15.65-40.24,34.21,0,19.22,13.19,32.64,37.78,32.64,21.47,0,37.11-8.72,44.72-25.49v5.59c0,12.3,5.14,17.66,16.76,17.66a58.66,58.66,0,0,0,6.93-.45v-7.6c-1.56,0-3.57.23-5.36.23C1147.67,376.74,1144.76,373.61,1144.76,366.45Zm-8.94-29.95c0,29.73-20.12,42.47-44,42.47-19.45,0-28.84-10.51-28.84-25,0-15.42,9.84-23.47,32.19-26.38l18.56-2.45c11.62-1.57,18.33-4.25,22.13-8.72Zm38-111.56H1183V384.11h-9.17Z" />
        <text
          style={{ fontSize: '224px', letterSpacing: '0em' }}
          className="font-display font-extralight"
          fill="rgba(0,0,0,0.01)"
          transform="translate(0 384.92)"
        >
          NDC Journal
        </text>
      </StyledSvg>
    </Left>
    <Right>
      <Description
        dangerouslySetInnerHTML={{
          __html: description,
        }}
      />
    </Right>
  </Container>
);

JournalLogo.propTypes = {
  description: PropTypes.string,
};

export default JournalLogo;
